import React from "react";

const ProIcon = ({ color = "#00deff", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 17 15"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.99027 1.22422C8.89067 1.04711 8.70325 0.9375 8.5 0.9375C8.29682 0.9375 8.1094 1.04711 8.0098 1.22422L4.94467 6.6733L1.33088 4.04509C1.13804 3.90484 0.877727 3.90142 0.681264 4.03654C0.484802 4.17167 0.394884 4.41598 0.456879 4.64623L3.08188 14.3962C3.148 14.6418 3.3707 14.8125 3.62504 14.8125H13.375C13.6294 14.8125 13.8521 14.6418 13.9182 14.3962L16.5432 4.64623C16.6052 4.41598 16.5152 4.17167 16.3188 4.03654C16.1223 3.90142 15.862 3.90484 15.6692 4.04509L12.0554 6.6733L8.99027 1.22422ZM8.5 10.125C7.8787 10.125 7.375 10.6287 7.375 11.25C7.375 11.8713 7.8787 12.375 8.5 12.375H8.5075C9.1288 12.375 9.6325 11.8713 9.6325 11.25C9.6325 10.6287 9.1288 10.125 8.5075 10.125H8.5Z"
      fill={color}
    />
  </svg>
);

export default ProIcon;
